var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgA4Printer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 637.594 926.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 361.925,
    y1: 376.049,
    x2: 361.925,
    y2: 555.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b7b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b0a8a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 396.994,
    y1: 306.57,
    x2: 396.994,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7b299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d8c1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Machnes_and_dividers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 171.39,
    y: 574.37,
    width: 447.953,
    height: 347.478,
    rx: 14.682,
    ry: 14.682,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.39,
    y: 578.37,
    width: 447.953,
    height: 347.478,
    rx: 14.682,
    ry: 14.682,
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 593.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 593.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(821.25 402.904) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258.113,
    y: 593.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.112,
    y: 593.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(876.734 347.419) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.598,
    y: 593.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.597,
    y: 593.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(932.218 291.934) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 593.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 593.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(987.702 236.448) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.569,
    y: 593.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.568,
    y: 593.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1043.186 180.963) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 480.054,
    y: 593.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.053,
    y: 593.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1098.67 125.478) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 593.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 593.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1154.154 69.992) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 591.025,
    y: 593.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.024,
    y: 593.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1209.638 14.507) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 649.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 649.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(877.259 458.912) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258.113,
    y: 649.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.112,
    y: 649.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(932.743 403.426) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.598,
    y: 649.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.597,
    y: 649.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(988.227 347.941) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 649.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 649.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1043.711 292.456) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.569,
    y: 649.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.568,
    y: 649.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1099.195 236.97) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 480.054,
    y: 649.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.053,
    y: 649.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1154.679 181.485) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 649.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 649.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1210.163 125.999) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 591.025,
    y: 649.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.024,
    y: 649.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1265.647 70.514) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 705.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 705.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(933.267 514.919) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258.113,
    y: 705.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.112,
    y: 705.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(988.751 459.434) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.598,
    y: 705.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.597,
    y: 705.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1044.235 403.948) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 705.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 705.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1099.72 348.463) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.569,
    y: 705.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.568,
    y: 705.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1155.204 292.978) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 480.054,
    y: 705.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.053,
    y: 705.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1210.688 237.492) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 705.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 705.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1266.172 182.007) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 591.025,
    y: 705.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.024,
    y: 705.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1321.656 126.521) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 761.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 761.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(989.276 570.926) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258.113,
    y: 761.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.112,
    y: 761.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1044.76 515.441) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.598,
    y: 761.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.597,
    y: 761.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1100.244 459.956) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 761.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 761.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1155.728 404.47) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.569,
    y: 761.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.568,
    y: 761.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1211.212 348.985) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 480.054,
    y: 761.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.053,
    y: 761.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1266.696 293.5) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 761.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 761.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1322.18 238.014) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 591.025,
    y: 761.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.024,
    y: 761.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1377.664 182.529) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 817.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 817.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1045.285 626.934) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258.113,
    y: 817.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.112,
    y: 817.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1100.769 571.448) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.598,
    y: 817.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.597,
    y: 817.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1156.253 515.963) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 817.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 817.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1211.737 460.478) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.569,
    y: 817.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.568,
    y: 817.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1267.221 404.992) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 480.054,
    y: 817.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.053,
    y: 817.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1322.705 349.507) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 817.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 817.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1378.189 294.021) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 591.025,
    y: 817.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.024,
    y: 817.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1433.673 238.536) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 873.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.627,
    y: 873.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1101.293 682.941) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258.113,
    y: 873.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.112,
    y: 873.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1156.777 627.456) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.598,
    y: 873.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.597,
    y: 873.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1212.262 571.97) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 873.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.083,
    y: 873.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1267.746 516.485) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.569,
    y: 873.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.568,
    y: 873.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1323.23 461) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 480.054,
    y: 873.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.053,
    y: 873.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1378.714 405.514) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 873.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.539,
    y: 873.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1434.198 350.029) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 591.025,
    y: 873.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.024,
    y: 873.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1489.682 294.543) rotate(89.999)",
    fill: "#aa7552"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "610.62 561.677 174.67 561.677 13.59 518.147 386.89 518.147 610.62 561.677",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.67,
    y: 561.677,
    width: 435.95,
    height: 10.693,
    fill: "#f2c2a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.59 528.84 174.67 572.37 174.67 561.677 13.59 518.147 13.59 528.84",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M383.896,609.897v4.99c0,1.04-.16,2.05-.46,2.99-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01-.3-.94-.46-1.95-.46-2.99v-4.99h127.515Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.377,
    y: 603.09,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.492,
    y: 603.09,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.436,617.877c-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01h126.595Z",
    fill: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M550.353,609.897v4.99c0,1.04-.16,2.05-.46,2.99-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01-.3-.94-.46-1.95-.46-2.99v-4.99h127.515Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.833,
    y: 603.09,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.949,
    y: 603.09,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.893,617.877c-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01h126.595Z",
    fill: "#333"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "149.57 3 149.57 926.77 0 834.36 0 41.66 149.57 3",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.645,
    y: 3,
    width: 13.499,
    height: 923.77,
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.566,94.328h0c-1.04,.166-1.882-.521-1.882-1.533V55.152c0-1.013,.842-2.006,1.882-2.22h0c1.043-.214,1.89,.437,1.89,1.454v37.8c0,1.017-.847,1.976-1.89,2.143Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.242,78.209v-7.215c0-2.009,1.665-3.955,3.727-4.347l3.2-.609c2.086-.397,3.784,.927,3.784,2.96v7.3c0,2.033-1.698,3.977-3.784,4.341l-3.2,.558c-2.062,.36-3.727-.979-3.727-2.988Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.847,91.729h0c-1.078,.172-1.95-.524-1.95-1.555V51.859c0-1.031,.872-2.045,1.95-2.266h0c1.08-.222,1.958,.437,1.958,1.473v38.478c0,1.035-.878,2.014-1.958,2.187Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.331,75.339v-7.343c0-2.045,1.725-4.031,3.861-4.438l3.316-.631c2.162-.412,3.922,.931,3.922,3.001v7.432c0,2.07-1.76,4.054-3.921,4.431l-3.316,.578c-2.136,.373-3.861-.984-3.861-3.029Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.721,89.036h0c-1.117,.178-2.021-.528-2.021-1.578V48.446c0-1.049,.904-2.086,2.021-2.315h0c1.12-.23,2.03,.438,2.03,1.492v39.181c0,1.054-.91,2.054-2.03,2.232Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.003,72.365v-7.476c0-2.082,1.788-4.11,4.002-4.532l3.438-.655c2.242-.427,4.067,.934,4.067,3.042v7.568c0,2.107-1.825,4.134-4.066,4.525l-3.438,.599c-2.215,.386-4.003-.99-4.003-3.072Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.222,86.242h0c-1.159,.185-2.097-.532-2.097-1.601V44.906c0-1.069,.938-2.128,2.097-2.366h0c1.162-.238,2.106,.438,2.106,1.512v39.91c0,1.074-.944,2.095-2.106,2.28Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.29,69.281v-7.614c0-2.12,1.854-4.192,4.152-4.63l3.566-.679c2.326-.443,4.22,.937,4.22,3.084v7.71c0,2.147-1.894,4.217-4.219,4.623l-3.566,.622c-2.297,.401-4.152-.995-4.152-3.115Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.384,83.343h0c-1.203,.192-2.177-.535-2.177-1.624V41.233c0-1.089,.973-2.172,2.177-2.419h0c1.206-.247,2.187,.438,2.187,1.532v40.666c0,1.094-.98,2.137-2.187,2.33Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.227,66.081v-7.757c0-2.16,1.925-4.278,4.31-4.732l3.703-.705c2.415-.46,4.381,.939,4.381,3.127v7.856c0,2.188-1.966,4.304-4.381,4.725l-3.703,.646c-2.385,.416-4.31-1-4.31-3.16Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.247,80.332h0c-1.25,.2-2.262-.539-2.262-1.649V37.419c0-1.11,1.011-2.217,2.262-2.474h0c1.253-.257,2.272,.438,2.272,1.553v41.452c0,1.115-1.018,2.182-2.272,2.382Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.851,62.759v-7.906c0-2.202,1.999-4.367,4.477-4.839l3.847-.732c2.509-.478,4.553,.941,4.553,3.171v8.009c0,2.23-2.043,4.394-4.552,4.832l-3.847,.671c-2.478,.432-4.477-1.004-4.477-3.206Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.852,77.203h0c-1.3,.207-2.351-.542-2.351-1.674V33.455c0-1.132,1.051-2.265,2.351-2.532h0c1.303-.267,2.362,.437,2.362,1.574v42.269c0,1.137-1.059,2.228-2.362,2.436Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.203,59.306v-8.06c0-2.245,2.078-4.46,4.654-4.95l4-.762c2.609-.497,4.734,.942,4.734,3.217v8.167c0,2.274-2.125,4.489-4.734,4.944l-4,.697c-2.576,.449-4.654-1.008-4.654-3.253Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.244,73.948h0c-1.353,.216-2.446-.545-2.446-1.7V29.333c0-1.154,1.094-2.315,2.446-2.592h0c1.356-.278,2.458,.436,2.458,1.596v43.119c0,1.16-1.102,2.276-2.458,2.493Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.325,55.717v-8.221c0-2.289,2.162-4.557,4.841-5.067l4.162-.792c2.715-.517,4.927,.943,4.927,3.263v8.332c0,2.32-2.211,4.587-4.927,5.06l-4.162,.726c-2.68,.467-4.842-1.012-4.842-3.301Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.566,156.73h0c-1.04,.095-1.882-.65-1.882-1.662v-37.643c0-1.013,.842-1.948,1.882-2.09h0c1.043-.142,1.89,.566,1.89,1.583v37.8c0,1.017-.847,1.918-1.89,2.013Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.242,140.245v-7.215c0-2.009,1.665-3.841,3.727-4.092l3.2-.39c2.086-.254,3.784,1.187,3.784,3.22v7.3c0,2.033-1.698,3.86-3.784,4.081l-3.2,.339c-2.062,.218-3.727-1.235-3.727-3.244Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.847,155.248h0c-1.078,.098-1.95-.658-1.95-1.689v-38.316c0-1.031,.872-1.985,1.95-2.132h0c1.08-.147,1.958,.572,1.958,1.607v38.478c0,1.035-.878,1.954-1.958,2.052Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.331,138.479v-7.343c0-2.045,1.725-3.913,3.861-4.173l3.316-.404c2.162-.263,3.922,1.2,3.922,3.27v7.432c0,2.07-1.76,3.933-3.921,4.162l-3.316,.351c-2.136,.226-3.861-1.249-3.861-3.294Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.721,153.712h0c-1.117,.102-2.021-.667-2.021-1.716v-39.013c0-1.049,.904-2.024,2.021-2.176h0c1.12-.153,2.03,.577,2.03,1.631v39.181c0,1.054-.91,1.991-2.03,2.093Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.003,136.649v-7.476c0-2.082,1.788-3.987,4.002-4.257l3.438-.419c2.242-.273,4.067,1.213,4.067,3.321v7.568c0,2.107-1.825,4.009-4.066,4.246l-3.438,.364c-2.215,.234-4.003-1.264-4.003-3.346Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.222,152.12h0c-1.159,.105-2.097-.676-2.097-1.745v-39.735c0-1.069,.938-2.063,2.097-2.222h0c1.162-.159,2.106,.583,2.106,1.656v39.91c0,1.074-.944,2.03-2.106,2.136Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.29,134.751v-7.614c0-2.12,1.854-4.065,4.152-4.345l3.566-.434c2.326-.283,4.22,1.226,4.22,3.373v7.71c0,2.147-1.894,4.087-4.219,4.333l-3.566,.377c-2.297,.243-4.152-1.28-4.152-3.4Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.384,150.467h0c-1.203,.11-2.177-.685-2.177-1.774v-40.485c0-1.089,.973-2.105,2.177-2.269h0c1.206-.165,2.187,.588,2.187,1.682v40.666c0,1.094-.98,2.07-2.187,2.18Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.227,132.782v-7.757c0-2.16,1.925-4.146,4.31-4.436l3.703-.451c2.415-.294,4.381,1.24,4.381,3.428v7.856c0,2.188-1.966,4.169-4.381,4.425l-3.703,.392c-2.385,.252-4.31-1.295-4.31-3.456Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.247,148.75h0c-1.25,.114-2.262-.694-2.262-1.804v-41.264c0-1.11,1.011-2.148,2.262-2.319h0c1.253-.171,2.272,.594,2.272,1.709v41.452c0,1.115-1.018,2.112-2.272,2.226Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.851,130.737v-7.906c0-2.202,1.999-4.23,4.477-4.532l3.847-.469c2.509-.306,4.553,1.253,4.553,3.484v8.009c0,2.23-2.043,4.254-4.552,4.52l-3.847,.407c-2.478,.262-4.477-1.311-4.477-3.513Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.852,146.966h0c-1.3,.118-2.351-.704-2.351-1.835v-42.074c0-1.132,1.051-2.193,2.351-2.37h0c1.303-.178,2.362,.599,2.362,1.736v42.269c0,1.137-1.059,2.155-2.362,2.274Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.202,128.613v-8.06c0-2.245,2.078-4.317,4.654-4.631l4-.487c2.609-.318,4.734,1.267,4.734,3.541v8.167c0,2.274-2.125,4.343-4.734,4.619l-4,.423c-2.576,.272-4.654-1.327-4.654-3.572Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.244,145.11h0c-1.353,.123-2.446-.713-2.446-1.868v-42.915c0-1.154,1.094-2.24,2.446-2.424h0c1.356-.185,2.458,.605,2.458,1.765v43.119c0,1.16-1.102,2.201-2.458,2.324Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.325,126.404v-8.221c0-2.289,2.162-4.408,4.841-4.735l4.162-.507c2.715-.331,4.927,1.281,4.927,3.601v8.332c0,2.32-2.211,4.435-4.927,4.722l-4.162,.44c-2.68,.283-4.842-1.344-4.842-3.633Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.566,219.131h0c-1.04,.023-1.882-.779-1.882-1.791v-37.643c0-1.013,.842-1.891,1.882-1.961h0c1.043-.071,1.89,.696,1.89,1.713v37.8c0,1.017-.847,1.86-1.89,1.883Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.242,202.281v-7.215c0-2.009,1.665-3.726,3.727-3.836l3.2-.17c2.086-.111,3.784,1.447,3.784,3.48v7.3c0,2.033-1.698,3.744-3.784,3.822l-3.2,.119c-2.062,.077-3.727-1.49-3.727-3.499Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.847,218.767h0c-1.078,.024-1.95-.792-1.95-1.823v-38.316c0-1.031,.872-1.926,1.95-1.999h0c1.08-.073,1.958,.706,1.958,1.741v38.478c0,1.035-.878,1.894-1.958,1.918Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.331,201.619v-7.343c0-2.045,1.725-3.794,3.861-3.908l3.316-.176c2.162-.115,3.922,1.469,3.922,3.539v7.432c0,2.07-1.76,3.813-3.921,3.893l-3.316,.123c-2.136,.079-3.861-1.514-3.861-3.559Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.721,218.389h0c-1.117,.025-2.021-.805-2.021-1.855v-39.013c0-1.049,.904-1.962,2.021-2.038h0c1.12-.076,2.03,.717,2.03,1.771v39.181c0,1.054-.91,1.929-2.03,1.954Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.003,200.933v-7.476c0-2.082,1.788-3.865,4.002-3.982l3.438-.183c2.242-.119,4.067,1.492,4.067,3.6v7.568c0,2.107-1.825,3.884-4.066,3.967l-3.438,.128c-2.215,.082-4.003-1.539-4.003-3.621Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.221,217.997h0c-1.159,.026-2.097-.82-2.097-1.888v-39.735c0-1.069,.938-1.999,2.097-2.078h0c1.162-.079,2.106,.727,2.106,1.801v39.91c0,1.074-.944,1.965-2.106,1.991Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.29,200.221v-7.614c0-2.12,1.854-3.938,4.152-4.06l3.566-.19c2.326-.124,4.22,1.516,4.22,3.663v7.71c0,2.147-1.894,3.958-4.219,4.044l-3.566,.133c-2.297,.085-4.152-1.565-4.152-3.685Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.384,217.59h0c-1.203,.027-2.177-.834-2.177-1.923v-40.485c0-1.089,.973-2.038,2.177-2.12h0c1.206-.082,2.187,.738,2.187,1.832v40.666c0,1.094-.98,2.003-2.187,2.03Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.226,199.483v-7.757c0-2.16,1.925-4.014,4.31-4.141l3.703-.197c2.415-.128,4.381,1.541,4.381,3.728v7.856c0,2.188-1.966,4.034-4.381,4.124l-3.703,.138c-2.385,.089-4.31-1.591-4.31-3.751Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.247,217.168h0c-1.25,.028-2.262-.849-2.262-1.959v-41.264c0-1.11,1.011-2.079,2.262-2.163h0c1.253-.085,2.272,.75,2.272,1.865v41.452c0,1.115-1.018,2.042-2.272,2.07Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.851,198.716v-7.906c0-2.202,1.999-4.093,4.477-4.224l3.847-.205c2.509-.133,4.553,1.566,4.553,3.796v8.009c0,2.23-2.043,4.114-4.552,4.207l-3.847,.143c-2.478,.092-4.477-1.618-4.477-3.82Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.852,216.729h0c-1.3,.029-2.351-.865-2.351-1.997v-42.074c0-1.132,1.051-2.121,2.351-2.209h0c1.303-.089,2.362,.761,2.362,1.898v42.269c0,1.137-1.059,2.083-2.362,2.112Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.202,197.92v-8.06c0-2.245,2.078-4.175,4.654-4.312l4-.213c2.609-.139,4.734,1.592,4.734,3.866v8.167c0,2.274-2.125,4.197-4.734,4.294l-4,.149c-2.576,.096-4.654-1.647-4.654-3.891Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.244,216.272h0c-1.353,.03-2.446-.881-2.446-2.036v-42.915c0-1.154,1.094-2.165,2.446-2.256h0c1.356-.092,2.458,.773,2.458,1.933v43.119c0,1.16-1.102,2.125-2.458,2.155Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.325,197.091v-8.221c0-2.289,2.162-4.26,4.841-4.403l4.162-.221c2.715-.144,4.927,1.619,4.927,3.939v8.332c0,2.32-2.211,4.283-4.927,4.384l-4.162,.155c-2.68,.1-4.842-1.676-4.842-3.965Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.566,281.533h0c-1.04-.048-1.882-.908-1.882-1.921v-37.643c0-1.013,.842-1.833,1.882-1.832h0c1.043,0,1.89,.826,1.89,1.842v37.8c0,1.017-.847,1.802-1.89,1.754Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.242,264.318v-7.215c0-2.009,1.665-3.612,3.727-3.58l3.2,.049c2.086,.032,3.784,1.706,3.784,3.739v7.3c0,2.033-1.698,3.627-3.784,3.562l-3.2-.101c-2.062-.065-3.727-1.746-3.727-3.755Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.847,282.285h0c-1.078-.05-1.95-.926-1.95-1.956v-38.316c0-1.031,.872-1.866,1.95-1.865h0c1.08,0,1.958,.84,1.958,1.876v38.478c0,1.035-.878,1.834-1.958,1.784Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.331,264.759v-7.343c0-2.045,1.725-3.676,3.861-3.643l3.316,.051c2.162,.033,3.922,1.738,3.922,3.808v7.432c0,2.07-1.76,3.692-3.921,3.624l-3.316-.104c-2.136-.067-3.861-1.779-3.861-3.824Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.721,283.065h0c-1.117-.052-2.021-.944-2.021-1.994v-39.013c0-1.049,.904-1.9,2.021-1.899h0c1.12,0,2.03,.856,2.03,1.91v39.181c0,1.054-.91,1.866-2.03,1.815Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.003,265.217v-7.476c0-2.082,1.788-3.742,4.002-3.708l3.438,.053c2.242,.035,4.067,1.771,4.067,3.879v7.568c0,2.107-1.825,3.758-4.066,3.688l-3.438-.108c-2.215-.07-4.003-1.814-4.003-3.896Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.221,283.874h0c-1.159-.054-2.097-.963-2.097-2.032v-39.735c0-1.069,.938-1.935,2.097-1.934h0c1.162,0,2.106,.872,2.106,1.945v39.91c0,1.074-.944,1.9-2.106,1.847Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.29,265.691v-7.614c0-2.12,1.854-3.811,4.152-3.775l3.566,.055c2.326,.036,4.22,1.805,4.22,3.952v7.71c0,2.147-1.894,3.828-4.219,3.754l-3.566-.112c-2.297-.072-4.152-1.849-4.152-3.97Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.384,284.713h0c-1.203-.056-2.177-.983-2.177-2.073v-40.485c0-1.089,.973-1.971,2.177-1.97h0c1.206,0,2.187,.888,2.187,1.982v40.666c0,1.094-.98,1.935-2.187,1.88Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.226,266.184v-7.757c0-2.16,1.925-3.882,4.31-3.845l3.703,.057c2.415,.037,4.381,1.841,4.381,4.029v7.856c0,2.188-1.966,3.899-4.381,3.823l-3.703-.116c-2.385-.075-4.31-1.887-4.31-4.047Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.247,285.585h0c-1.25-.058-2.262-1.004-2.262-2.114v-41.264c0-1.11,1.011-2.009,2.262-2.008h0c1.253,0,2.272,.906,2.272,2.021v41.452c0,1.115-1.018,1.972-2.272,1.914Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.851,266.695v-7.906c0-2.202,1.999-3.955,4.477-3.917l3.847,.059c2.509,.039,4.553,1.878,4.553,4.108v8.009c0,2.23-2.043,3.974-4.552,3.895l-3.847-.121c-2.478-.078-4.477-1.926-4.477-4.127Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.852,286.491h0c-1.3-.06-2.351-1.026-2.351-2.158v-42.073c0-1.132,1.051-2.049,2.351-2.048h0c1.303,0,2.362,.923,2.362,2.061v42.269c0,1.137-1.059,2.01-2.362,1.95Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.202,267.226v-8.06c0-2.245,2.078-4.032,4.654-3.992l4,.062c2.609,.04,4.734,1.917,4.734,4.191v8.167c0,2.274-2.125,4.051-4.734,3.969l-4-.126c-2.576-.081-4.654-1.966-4.654-4.211Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.244,287.434h0c-1.353-.063-2.446-1.049-2.446-2.203v-42.915c0-1.154,1.094-2.09,2.446-2.089h0c1.356,0,2.458,.942,2.458,2.102v43.119c0,1.16-1.102,2.049-2.458,1.987Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.325,267.778v-8.221c0-2.289,2.162-4.112,4.841-4.07l4.162,.064c2.715,.042,4.927,1.957,4.927,4.277v8.332c0,2.32-2.211,4.132-4.927,4.046l-4.162-.131c-2.68-.084-4.842-2.008-4.842-4.298Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.566,343.934h0c-1.04-.119-1.882-1.037-1.882-2.05v-37.643c0-1.013,.842-1.775,1.882-1.703h0c1.043,.072,1.89,.955,1.89,1.972v37.8c0,1.017-.847,1.744-1.89,1.624Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.242,326.354v-7.215c0-2.009,1.665-3.498,3.727-3.325l3.2,.269c2.086,.175,3.784,1.966,3.784,3.999v7.3c0,2.033-1.698,3.511-3.784,3.302l-3.2-.32c-2.062-.206-3.727-2.002-3.727-4.011Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.847,345.804h0c-1.078-.124-1.95-1.059-1.95-2.09v-38.316c0-1.031,.872-1.806,1.95-1.731h0c1.08,.075,1.958,.975,1.958,2.01v38.478c0,1.035-.878,1.773-1.958,1.649Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.331,327.899v-7.343c0-2.045,1.725-3.558,3.861-3.378l3.316,.279c2.162,.182,3.922,2.007,3.922,4.077v7.432c0,2.07-1.76,3.571-3.921,3.355l-3.316-.332c-2.136-.214-3.861-2.044-3.861-4.089Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.721,347.742h0c-1.117-.128-2.021-1.083-2.021-2.132v-39.013c0-1.049,.904-1.838,2.021-1.76h0c1.12,.078,2.03,.995,2.03,2.049v39.181c0,1.054-.91,1.804-2.03,1.675Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.003,329.501v-7.476c0-2.082,1.788-3.619,4.002-3.433l3.438,.289c2.242,.188,4.067,2.05,4.067,4.158v7.568c0,2.107-1.825,3.633-4.066,3.409l-3.438-.344c-2.215-.222-4.003-2.088-4.003-4.17Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.221,349.751h0c-1.159-.133-2.097-1.107-2.097-2.176v-39.735c0-1.069,.938-1.87,2.097-1.79h0c1.162,.081,2.106,1.016,2.106,2.09v39.91c0,1.074-.944,1.836-2.106,1.702Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.29,331.161v-7.614c0-2.12,1.854-3.683,4.152-3.49l3.566,.3c2.326,.195,4.22,2.095,4.22,4.242v7.71c0,2.147-1.894,3.698-4.219,3.465l-3.566-.357c-2.297-.23-4.152-2.134-4.152-4.255Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.384,351.837h0c-1.203-.138-2.177-1.133-2.177-2.222v-40.485c0-1.089,.973-1.904,2.177-1.821h0c1.206,.084,2.187,1.038,2.187,2.132v40.666c0,1.094-.98,1.868-2.187,1.73Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.226,332.885v-7.757c0-2.16,1.925-3.75,4.31-3.549l3.703,.311c2.415,.203,4.381,2.142,4.381,4.33v7.856c0,2.188-1.966,3.764-4.381,3.523l-3.703-.37c-2.385-.239-4.31-2.182-4.31-4.343Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.247,354.003h0c-1.25-.144-2.262-1.16-2.262-2.27v-41.264c0-1.11,1.011-1.94,2.262-1.853h0c1.253,.087,2.272,1.061,2.272,2.177v41.452c0,1.115-1.018,1.902-2.272,1.758Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.851,334.674v-7.906c0-2.202,1.999-3.818,4.477-3.61l3.847,.323c2.509,.211,4.553,2.191,4.553,4.421v8.009c0,2.23-2.043,3.834-4.552,3.583l-3.847-.385c-2.478-.248-4.477-2.233-4.477-4.434Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.852,356.254h0c-1.3-.149-2.351-1.188-2.351-2.319v-42.073c0-1.132,1.051-1.976,2.351-1.886h0c1.303,.09,2.362,1.086,2.362,2.223v42.269c0,1.137-1.059,1.937-2.362,1.788Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.202,336.533v-8.06c0-2.245,2.078-3.889,4.654-3.673l4,.336c2.609,.219,4.734,2.242,4.734,4.516v8.167c0,2.274-2.125,3.905-4.734,3.644l-4-.4c-2.576-.258-4.654-2.285-4.654-4.53Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.243,358.596h0c-1.353-.155-2.446-1.217-2.446-2.371v-42.915c0-1.154,1.094-2.015,2.446-1.921h0c1.356,.094,2.458,1.111,2.458,2.271v43.119c0,1.16-1.102,1.974-2.458,1.818Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.325,338.466v-8.221c0-2.289,2.162-3.963,4.841-3.738l4.162,.35c2.715,.228,4.927,2.295,4.927,4.615v8.332c0,2.32-2.211,3.98-4.927,3.708l-4.162-.416c-2.68-.268-4.842-2.34-4.842-4.63Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.566,406.336h0c-1.04-.191-1.882-1.166-1.882-2.179v-37.643c0-1.013,.842-1.717,1.882-1.574h0c1.043,.144,1.89,1.085,1.89,2.102v37.8c0,1.017-.847,1.686-1.89,1.495Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.242,388.39v-7.215c0-2.009,1.665-3.384,3.727-3.069l3.2,.488c2.086,.318,3.784,2.226,3.784,4.259v7.3c0,2.033-1.698,3.394-3.784,3.043l-3.2-.54c-2.062-.348-3.727-2.257-3.727-4.267Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.847,409.323h0c-1.078-.198-1.95-1.193-1.95-2.224v-38.316c0-1.031,.872-1.746,1.95-1.597h0c1.08,.149,1.958,1.109,1.958,2.144v38.478c0,1.035-.878,1.713-1.958,1.515Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.331,391.04v-7.343c0-2.045,1.725-3.439,3.861-3.113l3.316,.506c2.162,.33,3.922,2.276,3.922,4.346v7.432c0,2.07-1.76,3.45-3.921,3.086l-3.316-.559c-2.136-.36-3.861-2.309-3.861-4.354Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.721,412.418h0c-1.117-.205-2.021-1.222-2.021-2.271v-39.013c0-1.049,.904-1.776,2.021-1.621h0c1.12,.154,2.03,1.134,2.03,2.188v39.181c0,1.054-.91,1.742-2.03,1.536Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.002,393.785v-7.476c0-2.082,1.788-3.497,4.002-3.159l3.438,.525c2.242,.342,4.067,2.329,4.067,4.437v7.568c0,2.107-1.825,3.508-4.066,3.13l-3.438-.58c-2.215-.374-4.003-2.363-4.003-4.445Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.221,415.628h0c-1.159-.213-2.097-1.251-2.097-2.32v-39.735c0-1.069,.938-1.806,2.097-1.646h0c1.162,.16,2.106,1.161,2.106,2.234v39.91c0,1.074-.944,1.771-2.106,1.558Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.289,396.632v-7.614c0-2.12,1.854-3.556,4.152-3.205l3.566,.544c2.326,.355,4.22,2.385,4.22,4.531v7.71c0,2.147-1.894,3.568-4.219,3.175l-3.566-.602c-2.297-.388-4.152-2.419-4.152-4.54Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.384,418.96h0c-1.203-.221-2.177-1.282-2.177-2.371v-40.485c0-1.089,.973-1.838,2.177-1.672h0c1.206,.166,2.187,1.188,2.187,2.282v40.666c0,1.094-.98,1.801-2.187,1.58Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.226,399.585v-7.757c0-2.16,1.925-3.617,4.31-3.253l3.703,.565c2.415,.369,4.381,2.442,4.381,4.63v7.856c0,2.188-1.966,3.63-4.381,3.222l-3.703-.625c-2.385-.402-4.31-2.478-4.31-4.638Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.247,422.42h0c-1.25-.229-2.262-1.315-2.262-2.425v-41.264c0-1.11,1.011-1.87,2.262-1.698h0c1.253,.173,2.272,1.217,2.272,2.332v41.452c0,1.115-1.018,1.832-2.272,1.602Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.851,402.652v-7.906c0-2.202,1.999-3.681,4.477-3.303l3.847,.587c2.509,.383,4.553,2.503,4.553,4.733v8.009c0,2.23-2.043,3.693-4.552,3.27l-3.847-.649c-2.478-.418-4.477-2.54-4.477-4.742Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.852,426.017h0c-1.3-.238-2.351-1.349-2.351-2.481v-42.073c0-1.132,1.051-1.904,2.351-1.725h0c1.303,.18,2.362,1.248,2.362,2.385v42.269c0,1.137-1.059,1.865-2.362,1.626Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.202,405.839v-8.06c0-2.245,2.078-3.747,4.654-3.354l4,.611c2.609,.398,4.734,2.566,4.734,4.841v8.167c0,2.274-2.125,3.76-4.734,3.319l-4-.675c-2.576-.434-4.654-2.605-4.654-4.849Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.243,429.757h0c-1.353-.248-2.446-1.385-2.446-2.539v-42.915c0-1.154,1.094-1.939,2.446-1.753h0c1.356,.187,2.458,1.279,2.458,2.439v43.119c0,1.16-1.102,1.898-2.458,1.649Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.325,409.153v-8.221c0-2.289,2.162-3.815,4.841-3.406l4.162,.635c2.715,.414,4.927,2.633,4.927,4.953v8.332c0,2.32-2.211,3.828-4.927,3.37l-4.162-.702c-2.68-.452-4.842-2.673-4.842-4.962Z",
    fill: "#7f5640"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.015,484.612h0c-1.092-.287-1.976-1.318-1.976-2.304l-.003-36.621c0-.985,.883-1.574,1.975-1.317h0c1.093,.258,1.98,1.268,1.98,2.255l.005,36.717c0,.988-.887,1.556-1.981,1.269Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.416,466.605v-7.029c0-1.957,1.752-3.115,3.919-2.584l3.356,.821c2.183,.534,3.958,2.567,3.959,4.539v7.081c.002,1.972-1.773,3.12-3.957,2.565l-3.357-.853c-2.168-.551-3.921-2.583-3.921-4.541Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.985,489.071h0c-1.117-.293-2.021-1.339-2.021-2.336l-.01-37.034c0-.996,.903-1.59,2.019-1.326h0c1.118,.264,2.025,1.287,2.025,2.286l.012,37.132c0,.999-.907,1.571-2.025,1.277Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.256,470.845l-.002-7.108c0-1.979,1.791-3.145,4.007-2.602l3.432,.84c2.233,.546,4.048,2.607,4.049,4.601l.003,7.162c0,1.994-1.814,3.15-4.047,2.583l-3.433-.872c-2.217-.563-4.009-2.624-4.01-4.603Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.34,493.632h0c-1.142-.3-2.067-1.36-2.067-2.368l-.018-37.456c0-1.007,.923-1.605,2.065-1.336h0c1.143,.27,2.072,1.308,2.072,2.318l.02,37.557c0,1.011-.927,1.586-2.071,1.286Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.477,475.181l-.003-7.189c0-2.002,1.831-3.176,4.098-2.621l3.511,.859c2.284,.559,4.142,2.648,4.143,4.665l.004,7.244c.001,2.017-1.855,3.181-4.139,2.6l-3.511-.892c-2.267-.576-4.101-2.665-4.102-4.667Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.095,498.298h0c-1.168-.307-2.115-1.382-2.116-2.402l-.026-37.888c0-1.019,.944-1.621,2.112-1.346h0c1.17,.276,2.12,1.328,2.12,2.35l.028,37.992c0,1.022-.949,1.602-2.119,1.294Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.094,479.616l-.005-7.271c-.001-2.025,1.873-3.207,4.192-2.639l3.592,.879c2.337,.572,4.238,2.691,4.24,4.731l.006,7.328c.002,2.041-1.897,3.212-4.234,2.618l-3.593-.913c-2.32-.589-4.196-2.708-4.198-4.733Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.263,503.072h0c-1.196-.314-2.165-1.405-2.166-2.437l-.034-38.331c0-1.031,.966-1.638,2.161-1.356h0c1.197,.283,2.17,1.35,2.17,2.383l.037,38.437c0,1.034-.97,1.618-2.168,1.303Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.118,484.155l-.006-7.356c-.002-2.048,1.916-3.239,4.289-2.658l3.676,.9c2.392,.585,4.338,2.735,4.34,4.799l.007,7.414c.002,2.065-1.941,3.244-4.333,2.637l-3.677-.934c-2.374-.603-4.295-2.752-4.296-4.801Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.86,507.959h0c-1.224-.322-2.216-1.428-2.217-2.472l-.043-38.784c-.001-1.043,.988-1.654,2.212-1.365h0c1.225,.289,2.221,1.372,2.222,2.418l.045,38.892c.001,1.047-.993,1.634-2.219,1.312Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.565,488.799l-.008-7.443c-.002-2.072,1.96-3.271,4.39-2.677l3.763,.921c2.449,.599,4.441,2.78,4.444,4.869l.009,7.502c.003,2.089-1.986,3.277-4.435,2.655l-3.764-.956c-2.43-.618-4.396-2.797-4.399-4.87Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.899,512.962h0c-1.253-.329-2.269-1.452-2.271-2.509l-.053-39.247c-.001-1.055,1.012-1.671,2.264-1.375h0c1.255,.296,2.275,1.395,2.276,2.453l.055,39.358c.001,1.059-1.016,1.65-2.272,1.32Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.451,493.554l-.01-7.532c-.003-2.097,2.006-3.305,4.494-2.696l3.853,.943c2.507,.614,4.548,2.826,4.551,4.94l.011,7.592c.003,2.114-2.033,3.31-4.541,2.673l-3.854-.979c-2.488-.632-4.502-2.844-4.505-4.942Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.398,518.086h0c-1.284-.337-2.325-1.477-2.326-2.546l-.062-39.722c-.002-1.068,1.036-1.689,2.319-1.386h0c1.285,.303,2.33,1.418,2.332,2.489l.065,39.836c.002,1.072-1.041,1.667-2.327,1.329Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.79,498.424l-.012-7.622c-.003-2.122,2.054-3.339,4.602-2.715l3.947,.966c2.568,.629,4.659,2.874,4.663,5.014l.013,7.685c.004,2.14-2.082,3.344-4.651,2.692l-3.948-1.003c-2.548-.648-4.611-2.892-4.615-5.015Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.022,545.344h0c-1.093-.331-1.977-1.399-1.977-2.386l-.003-36.672c0-.986,.884-1.541,1.976-1.239h0c1.094,.302,1.982,1.349,1.982,2.338l.005,36.769c0,.99-.888,1.523-1.982,1.191Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.419,527.087v-7.039c0-1.96,1.753-3.049,3.922-2.431l3.359,.957c2.185,.623,3.961,2.729,3.961,4.704v7.092c.002,1.975-1.774,3.053-3.959,2.41l-3.359-.989c-2.169-.639-3.923-2.744-3.924-4.704Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.003,550.49h0c-1.117-.339-2.022-1.422-2.022-2.42l-.01-37.087c0-.997,.904-1.556,2.02-1.247h0c1.118,.309,2.027,1.37,2.027,2.37l.012,37.186c0,1.001-.908,1.537-2.027,1.198Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.271,532.008l-.002-7.118c0-1.982,1.792-3.077,4.01-2.445l3.435,.979c2.234,.637,4.051,2.773,4.052,4.77l.003,7.172c0,1.997-1.815,3.082-4.05,2.424l-3.435-1.011c-2.218-.653-4.012-2.788-4.013-4.77Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.371,555.753h0c-1.143-.346-2.069-1.445-2.069-2.455l-.018-37.511c0-1.009,.924-1.571,2.066-1.255h0c1.144,.316,2.073,1.393,2.074,2.404l.02,37.612c0,1.012-.928,1.551-2.073,1.204Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.504,537.041l-.003-7.199c0-2.004,1.833-3.107,4.101-2.46l3.513,1.001c2.286,.651,4.145,2.818,4.146,4.838l.004,7.254c.001,2.02-1.856,3.111-4.142,2.438l-3.514-1.034c-2.269-.668-4.104-2.833-4.105-4.838Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.14,561.138h0c-1.169-.354-2.117-1.469-2.117-2.49l-.026-37.944c0-1.02,.945-1.586,2.114-1.263h0c1.171,.323,2.121,1.415,2.122,2.438l.028,38.048c0,1.024-.949,1.566-2.12,1.211Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.134,542.189l-.005-7.282c-.001-2.028,1.874-3.136,4.195-2.475l3.595,1.024c2.339,.666,4.241,2.865,4.243,4.908l.006,7.339c.002,2.044-1.898,3.141-4.238,2.452l-3.595-1.058c-2.321-.683-4.199-2.88-4.201-4.908Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.322,566.648h0c-1.197-.363-2.166-1.494-2.167-2.527l-.035-38.388c0-1.032,.967-1.601,2.163-1.271h0c1.198,.331,2.171,1.439,2.172,2.474l.037,38.494c0,1.036-.971,1.581-2.17,1.218Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.172,547.457l-.006-7.367c-.002-2.051,1.917-3.167,4.292-2.49l3.679,1.048c2.394,.682,4.341,2.912,4.343,4.98l.007,7.425c.002,2.068-1.942,3.171-4.336,2.467l-3.68-1.083c-2.376-.699-4.298-2.928-4.3-4.98Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.933,572.288h0c-1.225-.371-2.218-1.519-2.219-2.565l-.043-38.842c-.001-1.044,.989-1.617,2.214-1.279h0c1.226,.339,2.223,1.463,2.224,2.51l.045,38.951c.001,1.048-.994,1.596-2.221,1.224Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.634,552.848l-.008-7.454c-.002-2.075,1.962-3.198,4.393-2.505l3.766,1.073c2.451,.698,4.445,2.962,4.447,5.054l.009,7.513c.003,2.092-1.988,3.202-4.439,2.481l-3.767-1.109c-2.432-.716-4.4-2.978-4.402-5.054Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.988,578.062h0c-1.255-.38-2.271-1.546-2.273-2.603l-.053-39.307c-.001-1.057,1.012-1.633,2.266-1.287h0c1.256,.347,2.276,1.488,2.278,2.548l.055,39.418c.001,1.061-1.017,1.612-2.274,1.231Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.534,558.368l-.01-7.543c-.003-2.1,2.008-3.229,4.497-2.52l3.856,1.099c2.509,.715,4.552,3.013,4.555,5.13l.011,7.604c.003,2.118-2.035,3.234-4.545,2.495l-3.857-1.135c-2.49-.733-4.506-3.029-4.508-5.129Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.503,583.976h0c-1.285-.389-2.327-1.573-2.328-2.643l-.062-39.783c-.002-1.07,1.037-1.65,2.321-1.295h0c1.286,.355,2.332,1.514,2.334,2.586l.065,39.897c.002,1.074-1.042,1.628-2.329,1.238Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.889,564.02l-.012-7.634c-.003-2.126,2.055-3.261,4.605-2.535l3.95,1.126c2.57,.732,4.663,3.065,4.667,5.208l.013,7.696c.004,2.143-2.084,3.266-4.654,2.509l-3.951-1.163c-2.551-.751-4.615-3.081-4.618-5.208Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.028,606.162h0c-1.093-.375-1.979-1.481-1.979-2.469l-.003-36.724c0-.987,.885-1.508,1.977-1.162h0c1.094,.347,1.983,1.43,1.983,2.42l.005,36.822c0,.991-.889,1.489-1.984,1.113Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.421,587.655v-7.049c0-1.963,1.754-2.983,3.925-2.277l3.361,1.093c2.187,.711,3.964,2.892,3.964,4.87v7.102c.002,1.978-1.775,2.986-3.962,2.254l-3.362-1.125c-2.171-.727-3.926-2.905-3.926-4.868Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.022,611.997h0c-1.118-.384-2.024-1.505-2.024-2.505l-.01-37.14c0-.999,.904-1.522,2.022-1.168h0c1.119,.354,2.028,1.454,2.028,2.455l.012,37.239c0,1.002-.908,1.503-2.028,1.118Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.285,593.259l-.002-7.128c0-1.985,1.794-3.01,4.013-2.288l3.437,1.118c2.236,.727,4.054,2.94,4.055,4.94l.003,7.182c0,2-1.816,3.013-4.053,2.265l-3.438-1.15c-2.22-.743-4.015-2.953-4.016-4.938Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.403,617.965h0c-1.144-.393-2.07-1.53-2.071-2.541l-.018-37.565c0-1.01,.925-1.536,2.068-1.174h0c1.145,.362,2.075,1.478,2.075,2.491l.02,37.667c0,1.014-.929,1.516-2.074,1.123Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.532,598.991l-.003-7.209c0-2.007,1.834-3.038,4.104-2.299l3.516,1.144c2.287,.744,4.148,2.989,4.149,5.011l.004,7.265c.001,2.023-1.857,3.041-4.145,2.276l-3.517-1.177c-2.271-.76-4.107-3.002-4.108-5.01Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.185,624.071h0c-1.17-.402-2.118-1.556-2.119-2.579l-.026-38c0-1.022,.946-1.55,2.115-1.18h0c1.171,.371,2.123,1.502,2.124,2.527l.028,38.104c0,1.025-.95,1.53-2.122,1.128Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.174,604.854l-.005-7.293c-.001-2.031,1.875-3.066,4.198-2.31l3.597,1.17c2.341,.761,4.244,3.039,4.246,5.085l.006,7.35c.002,2.047-1.9,3.069-4.241,2.286l-3.598-1.204c-2.323-.778-4.203-3.053-4.204-5.084Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.381,630.318h0c-1.198-.411-2.168-1.583-2.169-2.618l-.035-38.445c0-1.034,.967-1.565,2.164-1.186h0c1.199,.38,2.173,1.528,2.174,2.565l.037,38.551c0,1.038-.972,1.544-2.171,1.132Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.226,610.853l-.006-7.378c-.002-2.054,1.919-3.094,4.296-2.321l3.682,1.197c2.396,.779,4.345,3.091,4.347,5.161l.007,7.436c.002,2.071-1.944,3.098-4.34,2.296l-3.682-1.232c-2.378-.796-4.301-3.105-4.303-5.16Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.007,636.714h0c-1.226-.421-2.22-1.611-2.221-2.657l-.043-38.9c-.001-1.046,.99-1.58,2.215-1.192h0c1.227,.389,2.225,1.554,2.226,2.603l.046,39.009c.001,1.05-.995,1.559-2.223,1.137Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.702,616.993l-.008-7.465c-.002-2.079,1.963-3.124,4.397-2.332l3.769,1.226c2.452,.798,4.448,3.145,4.451,5.24l.009,7.525c.003,2.096-1.989,3.127-4.442,2.306l-3.77-1.262c-2.434-.815-4.403-3.159-4.406-5.238Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.077,643.262h0c-1.256-.431-2.273-1.639-2.274-2.698l-.053-39.367c-.001-1.059,1.013-1.595,2.268-1.198h0c1.257,.398,2.278,1.581,2.28,2.643l.055,39.478c.001,1.063-1.018,1.573-2.276,1.142Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.618,623.279l-.01-7.554c-.003-2.103,2.009-3.153,4.501-2.343l3.86,1.255c2.511,.817,4.556,3.2,4.559,5.32l.011,7.615c.003,2.121-2.036,3.157-4.548,2.316l-3.86-1.292c-2.492-.834-4.509-3.214-4.512-5.318Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.608,649.968h0c-1.286-.442-2.328-1.668-2.33-2.741l-.062-39.845c-.002-1.071,1.037-1.61,2.323-1.203h0c1.287,.408,2.334,1.609,2.336,2.684l.065,39.959c.002,1.075-1.043,1.588-2.331,1.146Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.989,629.716l-.012-7.646c-.003-2.129,2.057-3.184,4.609-2.353l3.953,1.286c2.573,.837,4.667,3.257,4.671,5.403l.013,7.708c.004,2.147-2.085,3.187-4.658,2.326l-3.954-1.323c-2.553-.854-4.619-3.271-4.622-5.401Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.034,667.067h0c-1.094-.42-1.98-1.562-1.98-2.552l-.003-36.777c0-.989,.885-1.474,1.979-1.084h0c1.095,.391,1.984,1.512,1.984,2.504l.005,36.874c0,.992-.889,1.456-1.985,1.035Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.424,648.308v-7.059c0-1.965,1.756-2.916,3.928-2.122l3.363,1.23c2.188,.8,3.967,3.055,3.967,5.036v7.112c.002,1.981-1.777,2.919-3.965,2.098l-3.364-1.262c-2.172-.815-3.929-3.067-3.929-5.033Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.04,673.593h0c-1.119-.429-2.025-1.588-2.025-2.589l-.01-37.193c0-1,.905-1.488,2.023-1.088h0c1.12,.4,2.029,1.537,2.03,2.54l.012,37.293c0,1.004-.909,1.468-2.03,1.038Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.299,654.598l-.002-7.138c0-1.988,1.795-2.942,4.016-2.13l3.44,1.258c2.238,.818,4.057,3.107,4.058,5.109l.003,7.193c0,2.003-1.818,2.945-4.056,2.106l-3.44-1.29c-2.222-.833-4.018-3.118-4.019-5.107Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.434,680.267h0c-1.145-.439-2.072-1.616-2.072-2.628l-.018-37.619c0-1.012,.925-1.501,2.069-1.093h0c1.146,.409,2.076,1.563,2.077,2.577l.02,37.721c0,1.015-.93,1.481-2.076,1.041Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.559,661.03l-.003-7.22c0-2.01,1.835-2.968,4.107-2.138l3.519,1.286c2.289,.837,4.151,3.159,4.152,5.185l.004,7.276c.001,2.026-1.859,2.971-4.148,2.112l-3.519-1.32c-2.272-.852-4.11-3.171-4.111-5.182Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.23,687.096h0c-1.171-.449-2.12-1.644-2.121-2.668l-.026-38.056c0-1.023,.946-1.515,2.117-1.097h0c1.172,.418,2.125,1.59,2.125,2.616l.028,38.16c0,1.027-.951,1.494-2.124,1.044Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.214,667.61l-.005-7.303c-.001-2.034,1.877-2.995,4.201-2.145l3.6,1.316c2.342,.856,4.248,3.214,4.249,5.263l.006,7.36c.002,2.05-1.901,2.997-4.244,2.119l-3.601-1.35c-2.325-.872-4.206-3.226-4.207-5.26Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.44,694.084h0c-1.199-.46-2.17-1.672-2.171-2.709l-.035-38.502c0-1.035,.968-1.528,2.166-1.101h0c1.2,.428,2.175,1.617,2.176,2.656l.037,38.609c0,1.039-.973,1.508-2.173,1.047Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.28,674.343l-.006-7.389c-.002-2.057,1.92-3.022,4.299-2.152l3.685,1.347c2.397,.876,4.348,3.27,4.35,5.344l.007,7.447c.002,2.074-1.945,3.024-4.343,2.125l-3.685-1.382c-2.379-.892-4.305-3.282-4.306-5.34Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.08,701.236h0c-1.227-.471-2.221-1.702-2.223-2.751l-.043-38.959c-.001-1.048,.991-1.542,2.217-1.105h0c1.228,.438,2.226,1.646,2.228,2.696l.046,39.068c.001,1.051-.995,1.521-2.224,1.049Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.771,681.234l-.008-7.476c-.002-2.082,1.965-3.049,4.4-2.159l3.772,1.379c2.454,.897,4.452,3.328,4.454,5.426l.009,7.536c.003,2.099-1.991,3.052-4.446,2.131l-3.773-1.415c-2.436-.914-4.407-3.34-4.409-5.422Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.166,708.56h0c-1.257-.482-2.275-1.733-2.276-2.794l-.053-39.427c-.001-1.06,1.014-1.557,2.27-1.108h0c1.258,.449,2.28,1.675,2.282,2.738l.055,39.539c.001,1.064-1.019,1.535-2.278,1.052Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.702,688.289l-.01-7.566c-.003-2.107,2.011-3.077,4.505-2.166l3.863,1.412c2.514,.919,4.559,3.388,4.563,5.511l.011,7.627c.003,2.124-2.038,3.08-4.552,2.137l-3.863-1.449c-2.494-.935-4.513-3.4-4.516-5.507Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.714,716.061h0c-1.287-.494-2.33-1.764-2.332-2.838l-.062-39.906c-.002-1.073,1.038-1.571,2.325-1.112h0c1.288,.46,2.336,1.706,2.338,2.782l.065,40.021c.002,1.077-1.043,1.549-2.333,1.054Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.088,695.514l-.012-7.658c-.003-2.132,2.059-3.106,4.613-2.172l3.957,1.447c2.575,.941,4.671,3.449,4.675,5.599l.013,7.72c.004,2.15-2.087,3.108-4.662,2.142l-3.957-1.484c-2.555-.958-4.623-3.462-4.626-5.594Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.041,728.059h0c-1.095-.464-1.981-1.644-1.982-2.635l-.003-36.829c0-.99,.886-1.441,1.98-1.006h0c1.096,.435,1.986,1.594,1.986,2.587l.005,36.927c0,.994-.89,1.422-1.986,.957Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.426,709.048v-7.069c0-1.968,1.757-2.85,3.93-1.968l3.366,1.366c2.19,.889,3.97,3.219,3.97,5.202v7.122c.002,1.983-1.778,2.852-3.968,1.942l-3.366-1.399c-2.174-.903-3.932-3.229-3.932-5.198Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.059,735.277h0c-1.12-.475-2.027-1.672-2.027-2.675l-.01-37.247c0-1.002,.906-1.453,2.025-1.009h0c1.121,.445,2.031,1.621,2.031,2.625l.012,37.347c0,1.005-.91,1.434-2.031,.958Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.314,716.024l-.002-7.149c0-1.99,1.796-2.874,4.019-1.972l3.442,1.397c2.239,.909,4.06,3.274,4.061,5.28l.003,7.203c0,2.006-1.819,2.876-4.059,1.946l-3.443-1.43c-2.223-.924-4.021-3.284-4.022-5.275Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.466,742.66h0c-1.145-.486-2.073-1.701-2.074-2.715l-.018-37.674c0-1.013,.926-1.466,2.071-1.011h0c1.147,.456,2.078,1.649,2.078,2.665l.02,37.776c0,1.017-.93,1.446-2.077,.959Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.586,723.159l-.003-7.23c0-2.013,1.837-2.899,4.11-1.976l3.521,1.43c2.291,.93,4.154,3.331,4.155,5.36l.004,7.286c.001,2.029-1.86,2.9-4.151,1.949l-3.522-1.463c-2.274-.945-4.113-3.341-4.114-5.355Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.275,750.214h0c-1.172-.497-2.121-1.731-2.122-2.757l-.026-38.112c0-1.025,.947-1.479,2.119-1.013h0c1.173,.466,2.126,1.678,2.127,2.705l.028,38.216c0,1.029-.951,1.458-2.125,.96Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.255,730.458l-.005-7.314c-.001-2.036,1.878-2.924,4.205-1.979l3.603,1.463c2.344,.952,4.251,3.389,4.253,5.442l.006,7.371c.002,2.053-1.903,2.925-4.247,1.951l-3.604-1.497c-2.327-.967-4.209-3.4-4.21-5.437Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.499,757.944h0c-1.2-.509-2.171-1.762-2.172-2.8l-.035-38.559c0-1.037,.969-1.492,2.168-1.015h0c1.201,.477,2.176,1.707,2.177,2.747l.037,38.666c0,1.041-.973,1.471-2.175,.961Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.335,737.927l-.006-7.4c-.002-2.06,1.922-2.949,4.302-1.982l3.687,1.497c2.399,.974,4.351,3.449,4.353,5.526l.007,7.458c.002,2.077-1.947,2.951-4.347,1.954l-3.688-1.532c-2.381-.989-4.308-3.46-4.31-5.521Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.154,765.857h0c-1.228-.521-2.223-1.794-2.224-2.844l-.044-39.017c-.001-1.049,.992-1.505,2.219-1.017h0c1.229,.488,2.228,1.738,2.229,2.79l.046,39.127c.001,1.053-.996,1.483-2.226,.962Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.84,745.571l-.008-7.488c-.002-2.085,1.966-2.975,4.404-1.985l3.775,1.533c2.456,.997,4.455,3.512,4.458,5.613l.009,7.547c.003,2.102-1.992,2.976-4.449,1.956l-3.776-1.569c-2.438-1.013-4.41-3.522-4.413-5.607Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.255,773.958h0c-1.258-.533-2.277-1.827-2.278-2.889l-.053-39.487c-.001-1.062,1.015-1.518,2.272-1.019h0c1.259,.5,2.282,1.769,2.283,2.834l.055,39.599c.001,1.066-1.02,1.496-2.279,.962Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.786,753.397l-.01-7.577c-.003-2.11,2.013-3.001,4.508-1.988l3.866,1.57c2.516,1.021,4.563,3.576,4.566,5.703l.011,7.639c.003,2.127-2.04,3.002-4.556,1.957l-3.867-1.606c-2.496-1.037-4.517-3.586-4.519-5.697Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.819,782.256h0c-1.288-.546-2.332-1.861-2.334-2.936l-.063-39.967c-.002-1.075,1.039-1.532,2.327-1.02h0c1.29,.512,2.338,1.802,2.34,2.88l.065,40.083c.002,1.079-1.044,1.509-2.334,.962Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.188,761.412l-.012-7.669c-.003-2.135,2.061-3.027,4.617-1.99l3.96,1.608c2.577,1.046,4.675,3.642,4.679,5.795l.013,7.732c.004,2.153-2.089,3.029-4.666,1.958l-3.961-1.645c-2.557-1.062-4.627-3.653-4.63-5.789Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.047,789.137h0c-1.096-.509-1.983-1.726-1.983-2.719l-.003-36.881c0-.992,.887-1.407,1.982-.928h0c1.097,.48,1.987,1.676,1.987,2.67l.005,36.979c0,.995-.89,1.388-1.988,.878Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.428,769.873v-7.079c0-1.971,1.758-2.783,3.933-1.812l3.368,1.504c2.191,.978,3.973,3.383,3.973,5.369v7.132c.002,1.986-1.779,2.784-3.971,1.785l-3.369-1.536c-2.176-.992-3.935-3.392-3.935-5.363Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.078,797.05h0c-1.121-.521-2.028-1.756-2.028-2.76l-.01-37.3c0-1.003,.906-1.419,2.026-.929h0c1.122,.491,2.032,1.705,2.033,2.711l.012,37.4c0,1.007-.91,1.399-2.033,.878Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.328,777.539l-.002-7.159c0-1.993,1.798-2.806,4.022-1.813l3.445,1.538c2.241,1.001,4.063,3.442,4.064,5.451l.003,7.214c0,2.009-1.82,2.807-4.062,1.785l-3.445-1.571c-2.225-1.014-4.024-3.451-4.025-5.445Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.497,805.144h0c-1.146-.533-2.075-1.787-2.075-2.802l-.018-37.729c0-1.014,.927-1.431,2.072-.929h0c1.147,.502,2.079,1.735,2.08,2.752l.02,37.831c0,1.018-.931,1.411-2.079,.877Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.613,785.378l-.003-7.241c0-2.016,1.838-2.829,4.113-1.813l3.524,1.573c2.293,1.024,4.157,3.503,4.158,5.534l.004,7.297c.001,2.032-1.862,2.83-4.155,1.784l-3.524-1.607c-2.276-1.038-4.117-3.511-4.117-5.528Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.32,813.425h0c-1.173-.545-2.123-1.819-2.124-2.846l-.026-38.168c0-1.026,.948-1.443,2.12-.93h0c1.174,.514,2.128,1.765,2.129,2.795l.028,38.273c0,1.03-.952,1.422-2.127,.876Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.295,793.398l-.005-7.325c-.001-2.039,1.88-2.852,4.208-1.813l3.606,1.61c2.346,1.047,4.254,3.565,4.256,5.621l.006,7.382c.002,2.056-1.904,2.853-4.251,1.783l-3.606-1.644c-2.329-1.062-4.212-3.574-4.214-5.614Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.558,821.899h0c-1.2-.558-2.173-1.852-2.174-2.891l-.035-38.617c0-1.038,.97-1.455,2.17-.93h0c1.202,.526,2.178,1.797,2.179,2.838l.037,38.724c0,1.042-.974,1.434-2.177,.875Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.389,801.605l-.006-7.411c-.002-2.063,1.923-2.876,4.306-1.812l3.69,1.648c2.401,1.072,4.355,3.629,4.357,5.709l.008,7.469c.002,2.08-1.948,2.877-4.35,1.782l-3.691-1.683c-2.383-1.087-4.311-3.638-4.313-5.702Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.228,830.574h0c-1.229-.571-2.225-1.886-2.226-2.938l-.044-39.076c-.001-1.051,.992-1.467,2.221-.929h0c1.23,.539,2.23,1.83,2.231,2.884l.046,39.186c.001,1.055-.997,1.445-2.228,.873Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.909,810.005l-.008-7.499c-.002-2.088,1.968-2.9,4.407-1.811l3.778,1.687c2.458,1.098,4.459,3.696,4.462,5.801l.009,7.559c.003,2.105-1.994,2.9-4.453,1.779l-3.779-1.723c-2.44-1.112-4.414-3.705-4.416-5.793Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.345,839.456h0c-1.259-.585-2.279-1.921-2.28-2.985l-.053-39.547c-.001-1.063,1.016-1.48,2.274-.929h0c1.26,.552,2.284,1.864,2.285,2.93l.055,39.66c.001,1.067-1.021,1.457-2.281,.871Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.87,818.605l-.01-7.589c-.003-2.113,2.014-2.924,4.512-1.809l3.869,1.727c2.518,1.124,4.567,3.765,4.57,5.895l.011,7.65c.003,2.131-2.041,2.925-4.56,1.777l-3.87-1.764c-2.498-1.139-4.52-3.773-4.523-5.887Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.924,848.554h0c-1.289-.599-2.334-1.957-2.336-3.035l-.063-40.029c-.002-1.076,1.04-1.492,2.329-.928h0c1.291,.565,2.34,1.899,2.341,2.978l.065,40.145c.002,1.08-1.045,1.469-2.336,.869Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.288,827.412l-.012-7.681c-.003-2.139,2.062-2.949,4.621-1.807l3.963,1.769c2.579,1.151,4.679,3.836,4.682,5.992l.013,7.744c.004,2.157-2.091,2.949-4.67,1.773l-3.964-1.807c-2.559-1.167-4.63-3.844-4.634-5.983Z",
    fill: "#7f5640"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M263.22,401.193v148.377l-65.677-15.004c-4.548-1.039-7.773-5.084-7.773-9.749v-130.233l73.45,6.61Z",
    fill: "#9d9289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.22,401.193v-32.273l-70.077,4.246c-1.895,.115-3.373,1.685-3.373,3.584v17.833l73.45,6.61Z",
    fill: "#292c2c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 253.57,
    y: 368.92,
    width: 216.71,
    height: 181.07,
    rx: 12,
    ry: 12,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.369,438.009c0-2.236,.136-2.372,2.372-2.372s2.372,.136,2.372,2.372-.136,2.372-2.372,2.372-2.372-.136-2.372-2.372Z",
    fill: "#4a3425"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350.743,473.589c-.542-.339-1.965-.678-3.117-.678s-3.66-.474-5.557-1.017c-3.389-1.017-3.524-1.152-3.524-3.389s.136-2.372,2.44-2.372c2.779,0,8.471,1.288,9.352,2.101,.407,.339,1.627,.61,2.846,.61,1.152,0,3.524,.203,5.286,.407,2.982,.407,3.117,.542,3.117,2.711v2.304h-4.88c-2.711,0-5.422-.339-5.964-.678h0Z",
    fill: "#893f1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.653,471.962v-2.304l4.541-.474c6.98-.745,11.114-2.033,19.111-6.032,6.235-3.185,7.997-4.405,11.521-8.336,2.304-2.508,5.557-7.116,7.184-10.098l3.05-5.557-4.88-.474c-2.711-.271-7.048-1.084-9.691-1.762-10.979-3.05-14.706-2.914-23.381,.474-2.236,.881-5.083,1.22-10.505,1.22-6.574,.068-8.065-.136-12.538-1.83-10.572-3.998-12.131-4.27-17.214-2.982-2.508,.61-7.319,2.372-10.708,3.863-3.389,1.491-6.574,2.711-7.048,2.711-1.355,0-1.152,1.423,.745,5.015,.949,1.762,1.694,4.066,1.694,5.218,0,1.83-.203,1.965-2.44,1.965-2.846,0-3.524-.61-5.896-5.354-2.44-4.947-2.508-11.589-.068-11.589,.474,0,3.727-1.22,7.184-2.779,10.098-4.405,12.199-4.947,20.874-4.947,7.387,.068,8.133,.203,14.232,2.575,9.285,3.592,10.64,3.66,18.637,1.017,6.099-2.033,7.523-2.236,14.571-2.236,6.438,0,8.946,.339,14.3,1.83,3.524,1.017,9.149,2.033,12.538,2.372l6.032,.474-.068,4.202c-.068,3.66-.474,4.88-3.727,10.776-5.218,9.556-10.505,14.91-18.434,18.84-3.456,1.694-7.048,3.117-7.997,3.117-1.017,0-2.169,.407-2.575,.949-1.017,1.22-7.997,2.44-14.164,2.44h-4.88v-2.304Z",
    fill: "#893f1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.692,445.328c-.881-.203-1.22-1.017-1.22-2.982,0-2.575,.068-2.643,2.44-2.643,3.66,0,5.015,1.017,5.015,3.727,0,2.304-.068,2.372-2.508,2.304-1.423-.068-3.117-.203-3.727-.407Z",
    fill: "#893f1a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M355.69,473.792c-3.389-.407-2.643-1.559,1.017-1.627,3.456-.068,3.253-.271-.678-.949-1.559-.203-2.575-.745-2.575-1.355,0-.813,1.559-.949,7.997-.949,9.081,0,16.265-1.22,22.5-3.727,2.372-.949,4.676-1.762,5.218-1.762,.474,0,.881-.271,.881-.61s.949-.949,2.169-1.491c1.152-.474,3.998-2.643,6.303-4.812,2.372-2.169,4.744-3.931,5.354-3.931s1.084-.542,1.084-1.288,.136-1.762,.407-2.304c.271-.745-.474-1.084-3.117-1.423-3.253-.407-3.592-.339-7.658,2.508-2.304,1.627-6.167,3.795-8.607,4.88-2.44,1.017-4.88,2.304-5.489,2.779-.542,.542-2.101,.949-3.389,.949s-2.643,.271-2.982,.61c-.813,.813-23.381-.203-28.464-1.22-9.217-1.83-20.806-8.471-23.855-13.622-.949-1.694-1.627-2.033-3.727-2.033-2.508,0-2.575-.068-2.575-2.372,0-2.033,.339-2.508,1.898-3.05,1.017-.407,2.643-1.152,3.66-1.762,1.017-.542,3.592-1.627,5.625-2.304l3.727-1.288v3.998c0,2.779-.271,4.202-.949,4.541-3.185,1.762,9.556,9.285,19.247,11.386,6.913,1.491,17.756,2.033,22.568,1.084,8.539-1.559,22.839-9.962,22.839-13.351,0-1.22,.407-1.627,1.559-1.694,.813,0-.136-.542-2.033-1.084-2.779-.813-3.592-1.355-3.592-2.44,0-1.491,.068-1.491,8.742,.881,2.779,.745,5.828,1.355,6.777,1.355,2.779,0,4.812,.745,4.812,1.762,0,1.084-3.117,1.22-8.336,.339-3.727-.61-3.524-.203,1.22,2.304,2.033,1.084,3.524,2.372,3.795,3.253,.271,1.22,.678,.745,2.372-2.711,1.491-3.321,2.236-4.202,3.321-4.066,.949,.068,1.288,.542,1.152,1.491-.542,3.05-7.116,13.961-11.047,18.23-3.456,3.795-5.422,5.218-11.386,8.2-8.404,4.27-7.319,5.083,1.22,.949,3.931-1.965,7.184-4.134,10.03-6.913,2.372-2.236,4.27-3.66,4.27-3.117,0,2.508-10.708,10.776-13.893,10.776-.542,0-1.017,.271-1.017,.61s-.881,.949-2.033,1.423c-1.084,.474-2.033,1.22-2.033,1.762s-1.152,1.017-2.846,1.22c-1.627,.203-6.235,.881-10.233,1.423-6.845,.949-14.232,1.152-19.247,.542h0Zm23.788-2.914c.881-.881,.203-.813-6.709,.339l-5.422,.949,5.693-.271c3.185-.203,6.032-.61,6.438-1.017Zm20.467-28.125c-1.559-1.152-2.44-1.288-2.44-.407,0,.339,.542,.813,1.22,.949,2.169,.61,2.508,.407,1.22-.542h0Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.136,471.014c-4.202-1.017-4.27-1.084-4.27-3.321,0-1.965,.203-2.236,1.898-2.236,1.017,0,4.066,.542,6.709,1.152,4.88,1.22,4.947,1.22,4.947,3.456,0,2.101-.136,2.169-2.508,2.101-1.423-.068-4.473-.542-6.777-1.152h0Zm6.235-.745c-.881-.745-7.184-2.304-7.59-1.83-.203,.203,1.152,.745,2.914,1.355,3.863,1.152,5.557,1.355,4.676,.474Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.147,452.919c0-.542-.271-1.017-.542-1.017-.949,0-3.05-4.337-2.779-5.693,.203-1.084,.474-.949,1.288,.678,1.152,2.169,2.372,3.66,3.05,3.66,.271,0,0-.745-.61-1.694-.61-.949-1.423-2.44-1.762-3.389-.542-1.491-.474-1.694,.949-1.694,1.084,0,1.898,.678,2.846,2.575,.678,1.355,1.491,2.643,1.83,2.711,.271,.136,.474,1.288,.474,2.575,0,2.169-.136,2.304-2.372,2.304-1.627,0-2.372-.339-2.372-1.017h0Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.484,452.444c3.117-4.812,6.642-12.063,6.777-14.096,.203-2.236,.068-2.372-2.169-2.779l-2.372-.474,2.711,.068c2.575,.136,2.711,.271,2.914,2.508,.203,1.83-.61,3.998-3.321,9.285-1.965,3.863-3.998,6.98-4.541,6.98-.813,0-.813-.203,0-1.491h0Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.318,438.212c-2.033-.542-2.575-1.017-2.575-2.169v-1.559l5.083,1.355c3.117,.813,5.083,1.694,5.083,2.304,0,1.017-3.727,1.084-7.59,.068Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.62,438.145c0-.745,.881-1.22,2.575-1.559,1.355-.271,3.727-.881,5.218-1.423,2.982-1.084,9.691-2.846,11.047-2.914,.407,0,.813,.61,.813,1.355,0,1.084-.474,1.355-2.372,1.355-1.288,0-2.372,.271-2.372,.61,0,.407-1.423,.881-3.185,1.152-1.83,.271-3.389,.745-3.592,1.017-.203,.339-2.101,.745-4.27,1.017-3.253,.407-3.863,.271-3.863-.61h0Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.475,434.349c-2.304-.745-3.253-1.423-3.253-2.372,0-1.084,.339-1.152,2.575-.745,3.389,.61,8.268,2.779,8.268,3.66,0,1.017-3.795,.745-7.59-.542h0Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.538,434.417c-1.83-.61-2.982-1.22-2.508-1.355,1.288-.407,8.878,1.288,8.878,1.965,0,.881-2.643,.678-6.37-.61h0Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.62,435.027c0-.339,1.559-.813,3.524-1.084,1.898-.271,3.931-.949,4.473-1.423,.474-.542,2.033-.949,3.389-.881,2.169,.068,1.762,.271-3.253,2.033-6.099,2.033-8.133,2.372-8.133,1.355h0Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.638,435.23c-4.676-.745-15.791-3.998-14.096-4.202,1.017-.136,3.998,.407,6.709,1.22,2.711,.813,6.506,1.627,8.539,1.83,1.965,.203,3.592,.678,3.592,.949,0,.61-1.491,.678-4.744,.203Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.246,433.333c0-1.084,5.422-3.185,8.065-3.05,1.423,.068,1.22,.203-1.017,.949-1.491,.474-3.727,1.355-4.88,1.965-1.83,.949-2.169,.949-2.169,.136h0Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.089,432.655c0-.881,1.898-1.762,3.931-1.762,.407,0,.813,.61,.813,1.355,0,1.084-.474,1.355-2.372,1.355-1.559,0-2.372-.339-2.372-.949Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.677,431.571c-1.694-.745-4.066-1.288-5.218-1.288-1.22-.068-2.236-.339-2.236-.745,0-1.017,3.321-.813,7.319,.339,2.169,.678,3.524,1.423,3.524,2.033,0,.542-.068,1.017-.136,.949-.136-.068-1.559-.61-3.253-1.288Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.529,430.893c0-.339,1.152-.678,2.575-.61,2.033,0,2.236,.136,1.152,.61-1.898,.813-3.727,.813-3.727,0Z",
    fill: "#af4504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.089,429.538c0-.339,1.084-.678,2.44-.678,1.423,0,2.236,.271,1.965,.678-.203,.407-1.288,.678-2.44,.678-1.084,0-1.965-.271-1.965-.678Z",
    fill: "#af4504"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.692,438.958v-3.389l2.508,.203c2.575,.203,4.066,1.898,1.694,1.898-1.084,0-1.355,.407-1.22,2.372,.068,2.033-.136,2.372-1.423,2.372-1.423,0-1.559-.339-1.559-3.456h0Z",
    fill: "#72523d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.758,440.042c0-.542,.339-1.017,.678-1.017,.407,0,.678,.474,.678,1.017s-.271,1.017-.678,1.017c-.339,0-.678-.474-.678-1.017Z",
    fill: "#72523d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.014,438.348c0-2.643,.068-2.711,2.372-2.711,1.627,0,2.372,.339,2.372,1.017,0,.542-.474,1.017-1.084,1.017-.813,0-1.017,.474-.813,1.694,.271,1.423,.068,1.694-1.22,1.694-1.423,0-1.627-.339-1.627-2.711Z",
    fill: "#816755"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.115,472.911c-11.589-1.152-27.583-8.065-34.157-14.842-4.337-4.541-7.929-9.827-8.539-12.605l-.474-2.033,1.423,2.236c.813,1.22,1.423,2.372,1.423,2.575,0,.61,2.101,2.508,2.44,2.169,.136-.203-.813-2.372-2.101-4.88-2.779-5.354-2.914-6.235-.813-6.845,.813-.271,5.015-1.898,9.285-3.592,4.27-1.694,8.946-3.321,10.369-3.524,2.304-.474,2.508-.407,2.508,1.084,0,1.288-.339,1.627-1.694,1.627-1.491,0-1.694,.271-1.694,2.575,0,1.423-.339,2.914-.813,3.389-1.017,1.017,.203,2.508,4.541,5.218,5.151,3.253,9.556,4.88,16.468,6.032,15.994,2.779,26.634,.474,38.968-8.268,2.44-1.762,3.185-2.711,3.185-4.134,0-2.033-2.101-3.456-5.083-3.456-1.355,0-1.694-.339-1.694-1.694,0-1.965-.271-1.965,9.827,.745,3.389,.881,8.539,1.83,11.521,2.101,5.286,.542,5.422,.61,5.218,2.236-.136,.949-1.423,3.795-2.914,6.37-1.423,2.575-2.643,4.947-2.643,5.286,0,1.355-9.285,10.233-12.877,12.334-7.997,4.676-18.569,7.794-26.634,7.929-1.965,0-4.134,.271-4.88,.61-.881,.407,1.694,.542,6.913,.407,5.151-.136,8.607-.474,9.217-1.017,.542-.407,1.288-.745,1.559-.678,1.288,.339,5.015-1.017,11.589-4.202,5.693-2.779,7.59-4.134,11.182-7.929,2.44-2.643,5.761-7.252,7.794-10.979,1.965-3.524,3.592-5.964,3.592-5.422s-1.22,3.117-2.711,5.693c-1.491,2.508-2.711,4.947-2.711,5.286,0,.407-2.033,2.779-4.541,5.422-4.744,4.88-9.624,8.2-15.249,10.369-2.304,.813-3.253,1.559-3.253,2.508,0,1.084-.474,1.288-3.863,1.152-2.169-.136-7.455,.203-11.724,.61-8.268,.881-10.437,.881-17.959,.136h0Zm7.455-1.355c-1.965-.813-9.081-.813-7.794,0,.542,.339,2.846,.61,5.083,.61,2.914,0,3.66-.203,2.711-.61Zm-11.589-1.152c.203-.271-1.627-1.017-4.134-1.694-5.489-1.423-5.151-1.355-4.608-.542,.203,.339,1.83,1.084,3.592,1.627,3.727,1.152,4.473,1.22,5.151,.61h0Zm3.795-4.134c0-.61-3.389-3.321-5.761-4.608-8.675-4.812-16.807-9.081-17.282-9.081-.339,0-2.711-2.101-5.354-4.676-3.727-3.66-5.218-4.744-7.116-4.947-1.355-.136-2.44-.203-2.44-.136,0,.136,1.83,2.508,4.066,5.286,4.744,5.964,9.285,9.759,14.706,12.267,2.169,.949,5.151,2.44,6.574,3.185,4.88,2.575,12.605,4.27,12.605,2.711h0Zm32.191-2.169c2.914-1.084,5.964-2.44,6.913-3.05,2.372-1.559,13.08-11.182,13.08-11.792,0-.271-1.288-.745-2.846-1.152-2.779-.61-3.117-.474-7.048,2.236-2.236,1.559-6.099,3.795-8.539,4.88-2.44,1.084-4.88,2.643-5.489,3.456-.61,.813-1.965,2.101-3.117,2.779-2.508,1.559-2.711,2.643-.407,2.643,1.084,0,1.694,.407,1.694,1.017,0,1.288-.271,1.355,5.761-1.017h0Zm-9.759-7.455c1.355,0,2.779-.407,3.185-.881,.407-.474,2.914-1.762,5.557-2.846,2.643-1.152,6.98-3.66,9.556-5.625l4.812-3.524,2.982,1.017c3.592,1.22,3.66,1.22,3.66,.339,0-.407-.745-1.017-1.694-1.355-.881-.339-2.846-1.423-4.405-2.372l-2.711-1.694v1.627c0,3.863-15.045,12.199-24.804,13.622-6.303,.949-15.858,.407-24.398-1.355-10.843-2.236-20.06-7.997-22.365-14.029-.339-.949-.068-1.22,1.288-1.22,.949,0,1.965-.339,2.169-.745,.881-1.355-.339-1.491-2.846-.407-1.423,.61-3.592,1.288-4.744,1.491-3.185,.61-3.795,2.033-.678,1.491,2.236-.339,2.575-.203,3.863,1.965,3.592,5.761,15.452,12.402,25.414,14.232,4.202,.745,22.297,1.355,23.042,.813,.339-.339,1.762-.542,3.117-.542h0Zm33.682-16.604c-.203-.203-2.033-.542-3.998-.745l-3.66-.339,3.389,1.898c3.185,1.83,3.456,1.898,3.998,.745,.339-.678,.474-1.423,.271-1.559Z",
    fill: "#c1601f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.928,438.958c-1.423-.339-4.337-1.423-6.438-2.372s-4.88-1.898-6.032-2.101c-1.83-.339-2.236-.678-2.236-2.033,0-1.559,.203-1.627,2.236-1.152,1.152,.203,4.947,1.491,8.268,2.779,9.285,3.592,13.554,3.727,24.059,.542,6.37-1.965,7.455-2.033,7.455-.542,0,.949-.881,1.627-3.185,2.44-8.471,2.982-17.892,3.931-24.127,2.44h0Z",
    fill: "#c1601f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.436,437.196c0-.542,5.761-3.117,13.419-6.032,2.372-.949,5.489-1.559,7.116-1.559,2.236,.136,2.44,.203,.813,.407-3.389,.474-7.794,1.965-14.435,4.88-6.777,2.982-6.913,3.05-6.913,2.304Z",
    fill: "#c1601f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.433,435.569c-3.389-.339-8.878-1.355-12.199-2.236-3.389-.949-6.913-1.83-7.861-1.965-1.22-.203-1.017-.339,.813-.407,1.423,0,5.151,.678,8.336,1.627,3.185,.881,8.268,1.898,11.25,2.101,2.982,.271,5.557,.745,5.761,1.017,.203,.339,.271,.542,.136,.542-.136-.068-2.914-.407-6.235-.678Z",
    fill: "#c1601f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.165,434.959c-.949-.271-3.795-1.355-6.438-2.372-2.575-1.017-6.099-2.033-7.794-2.372l-3.05-.542,3.185-.068c2.236-.068,4.947,.678,9.149,2.372,7.658,3.185,12.267,3.321,20.602,.745,3.185-1.017,6.642-1.762,7.794-1.762,1.762,.136,1.83,.136,.271,.407-.949,.136-4.541,1.22-7.997,2.304-6.303,1.965-12.063,2.44-15.723,1.288h0Z",
    fill: "#c1601f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.794,473.86c-7.59-1.152-15.994-4.066-22.636-7.861-10.505-5.964-20.467-18.434-20.467-25.55,0-3.389,1.152-2.44,3.795,3.117,2.711,5.693,3.931,7.319,5.015,6.642,.339-.203,.678-.136,.678,.271,0,.339,1.898,2.575,4.27,4.947,3.253,3.321,5.828,5.151,11.318,7.929,3.931,1.965,7.59,4.066,8.268,4.608,1.491,1.355,7.252,3.05,8.742,2.575,.678-.271,2.169,.068,3.321,.678,1.694,.881,4.134,1.017,14.164,.881,7.387-.136,12.47-.542,13.012-.949,.542-.407,1.423-.813,1.965-.813,2.236-.068,4.473-.881,11.114-4.202,8.065-3.931,13.351-8.81,17.688-16.401,1.491-2.575,2.914-4.608,3.185-4.608,.813,0,.678,3.795-.271,5.761-.407,.949-1.017,1.694-1.355,1.694-.271,0-.542,.474-.542,1.017s-.271,1.017-.678,1.017c-.339,0-.678,.474-.678,1.017,0,.61-.61,1.017-1.694,1.017-1.423,0-1.694,.339-1.694,1.898,0,2.101-2.44,4.88-4.27,4.88-.61,0-1.152,.407-1.152,.949,0,1.084-7.387,5.083-13.215,7.116-10.03,3.456-24.872,4.405-37.884,2.372h0Z",
    fill: "#9e6644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.641,469.862c-.203-.203-2.304-.678-4.676-1.084-2.372-.339-6.167-1.491-8.404-2.575-2.236-1.084-5.828-2.779-7.997-3.795-2.101-.949-5.422-2.982-7.252-4.473-3.795-2.982-12.334-13.351-11.792-14.3,.203-.271,0-.542-.474-.542-.407,0-.61-.542-.407-1.355,.203-.745,.068-1.22-.271-.949-.339,.203-.61-.136-.61-.678,0-.61,.407-1.152,.881-1.22,.407,0,1.152-.136,1.491-.136,.407-.068,1.084-.339,1.627-.678,.678-.407,.813-.339,.474,.136-.339,.542-.136,.678,.542,.407,.61-.203,.881-.678,.678-1.017s.203-.407,.813-.136c.881,.339,1.017,.203,.61-.474s-.271-.813,.542-.474c.678,.203,1.152,.136,1.152-.271s.339-.474,.678-.271c.407,.203,.678,.136,.678-.136,0-.339,.542-.61,1.22-.678,.61-.068,2.711-.813,4.541-1.627,3.727-1.694,4.27-1.83,10.098-2.372,2.169-.203,4.134-.136,4.405,.203,.339,.474,3.863,1.694,7.252,2.44,.474,.136,1.288,.61,1.898,1.084,.542,.474,1.83,.949,2.779,1.017,.949,0,1.694,.271,1.694,.61,0,.271,.813,.474,1.898,.474,1.423,0,1.627,.136,.813,.678-1.288,.813-5.422,.881-5.422,.068,0-.339-1.22-.745-2.711-1.017-1.694-.271-2.711-.813-2.711-1.423,0-1.559-1.22-1.898-6.37-1.762-13.215,.407-15.587,.745-16.672,2.779-.407,.745-1.762,1.423-3.389,1.694-1.491,.271-2.711,.745-2.711,1.084s-.678,.949-1.559,1.355c-1.288,.61-1.491,1.084-1.288,3.727,.203,2.508,.542,3.05,1.898,3.389,.881,.203,1.627,.678,1.627,.949,0,.339,1.898,2.508,4.27,4.88,3.253,3.321,5.828,5.151,11.182,7.861,3.863,1.965,7.861,4.202,8.946,4.947,1.22,.949,3.456,1.627,6.235,1.898,4.405,.474,8.607,2.033,5.557,2.101-.745,0-1.559-.136-1.762-.339h0Z",
    fill: "#9e6644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.383,469.726c1.22-.136,3.389-.136,4.744,0,1.423,.136,.474,.271-2.169,.271-2.575,0-3.727-.136-2.575-.271Z",
    fill: "#9e6644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.763,465.253c1.152-.949,6.642-3.66,6.37-3.117-.474,.678-5.354,3.321-6.167,3.321-.271,0-.339-.068-.203-.203h0Z",
    fill: "#9e6644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.96,452.648c0-.407,.271-.745,.61-.745s.813-.542,.949-1.152c.271-1.017,.339-1.017,.407-.136,0,.61-.407,1.491-.949,1.965-.678,.61-1.017,.61-1.017,.068Z",
    fill: "#9e6644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.193,439.364c.745-2.575,.407-3.727-1.152-3.727-.542,0-.949-.474-.949-1.017,0-.678,.745-1.017,2.372-1.017h2.372v4.066c0,3.863-.068,4.066-1.627,4.066s-1.627-.136-1.017-2.372Z",
    fill: "#9e6644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.686,436.789c1.694-.339,3.185-.813,3.389-1.084,.203-.203,1.288-.474,2.372-.542,1.152,0,1.627,.068,1.22,.271-.474,.136-.881,.745-.881,1.22,0,.745-1.084,.949-4.541,.881l-4.608-.068,3.05-.678h0Z",
    fill: "#9e6644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.861,436.315c-1.355-.407-1.423-.542-.339-.542,.745,0,2.101,.271,3.05,.542,1.355,.407,1.423,.542,.339,.542-.745,0-2.101-.271-3.05-.542Z",
    fill: "#9e6644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.818,435.095c0-1.83,11.521-3.863,12.47-2.236,.271,.407,1.288,.745,2.304,.745,3.863,0,3.185,1.017-.813,1.152-2.236,.068-6.37,.339-9.014,.542-3.05,.271-4.947,.203-4.947-.203h0Z",
    fill: "#9e6644"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M373.446,468.98c-.203-.203-.339-1.83-.339-3.66,0-2.779,.339-3.592,1.898-5.015,1.017-.881,2.779-2.508,3.863-3.592,1.152-1.152,3.795-2.779,5.896-3.727,2.169-.949,6.167-3.253,8.878-5.151l4.947-3.456,2.914,1.084c3.66,1.288,4.134,1.288,4.134,0,0-.542-.881-1.423-2.033-2.033-1.084-.61-2.033-1.355-2.033-1.694,0-.407-.474-.678-1.084-.678s-1.965-.61-3.05-1.423l-1.965-1.355v2.304c0,2.033-.407,2.711-3.185,4.676-9.962,7.048-17.756,9.624-29.006,9.488-8.742-.136-18.908-1.694-23.72-3.727-9.624-3.998-16.265-10.64-12.334-12.334,1.965-.881,2.508-3.389,.61-2.914-1.965,.542-1.152-1.83,.949-2.779,2.44-1.084,11.047-.949,13.419,.271,1.017,.542,2.711,1.017,3.66,1.017s2.304,.542,3.05,1.22c1.559,1.423,14.706,2.846,18.23,1.965,1.22-.339,3.389-.745,4.812-.949,1.355-.203,2.508-.61,2.508-.949s1.965-.61,4.337-.61c2.508,0,4.473-.339,4.608-.745,.407-1.288,7.523-.881,11.657,.678,2.101,.745,4.608,1.423,5.489,1.423,1.491,0,1.694,.271,1.694,2.372,0,1.627,.339,2.372,1.017,2.372,.61,0,1.017-.678,1.017-1.762,0-1.559,.203-1.694,2.914-1.491,2.643,.203,2.846,.339,3.05,2.372,.339,3.185-1.017,7.319-2.914,9.149-.949,.813-1.694,2.033-1.694,2.643,0,.949-6.032,6.709-11.047,10.572-3.931,3.05-19.721,7.794-21.145,6.438h0Z",
    fill: "#d87a13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.815,465.863c-2.575-1.22-5.828-2.779-7.184-3.456-2.101-.949-2.508-1.491-2.711-3.592-.203-2.169-.474-2.508-2.033-2.711-1.288-.136-1.898-.61-1.898-1.491,0-1.017-.407-1.152-2.575-.881-2.44,.339-2.711,.203-5.422-3.321-3.524-4.608-3.931-7.929-.949-8.065,1.559-.136,1.627-.136,.339-.407-2.236-.407-1.965-2.643,.474-3.931,2.304-1.22,2.711-1.22,2.711-.339,0,.407-.407,.678-.949,.678-1.017,0-1.898,1.627-1.288,2.304,.271,.203,1.288,.407,2.304,.407,1.423,0,3.05,1.152,6.709,4.744,2.643,2.575,5.083,4.744,5.422,4.744,.542,0,10.708,5.354,17.553,9.285,2.575,1.423,3.524,2.914,1.83,2.914-.813,0-1.084,.678-1.084,2.711v2.711h-3.253c-2.304,0-4.608-.678-7.997-2.304h0Z",
    fill: "#d87a13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M352.708,469.862c-.271-.203-2.372-.678-4.744-1.084-2.372-.339-6.167-1.491-8.404-2.575-2.236-1.084-5.828-2.779-7.997-3.795-2.101-.949-5.354-2.982-7.184-4.405-4.812-3.795-10.843-11.521-11.996-15.316-.542-1.762-.881-3.253-.813-3.389,.136-.068,1.152-.271,2.236-.474,1.152-.203,5.151-1.762,8.946-3.524,10.369-4.744,17.688-4.88,26.973-.61,8.268,3.727,14.706,3.727,26.092-.203,4.405-1.491,5.761-1.694,10.64-1.355,3.05,.203,6.167,.745,6.845,1.084,1.559,.813,9.691,2.508,15.249,3.185,2.846,.339,3.863,.678,3.863,1.491,0,2.101-6.099,13.419-8.404,15.655-2.169,2.101-2.44,2.236-2.44,.949,0-.745,.474-1.762,1.017-2.236s1.017-1.762,1.017-2.846c0-1.423,.407-2.101,1.288-2.372,.678-.136,1.559-1.017,1.965-1.83,.745-1.694,0-3.524-1.084-2.846-1.288,.813-5.557-1.491-9.488-5.083q-3.727-3.389-7.184-2.982c-1.898,.271-3.66,.813-3.863,1.152s-2.236,.678-4.405,.745c-2.169,0-4.202,.339-4.473,.745-.271,.407-1.491,.745-2.711,.813-2.779,.136-7.997,1.491-9.014,2.304-.474,.407-1.084,.339-1.559-.136-.407-.407-1.627-.813-2.643-.881s-3.389-.271-5.286-.542c-1.83-.203-2.914-.271-2.304-.068,1.017,.271,2.372,4.134,1.762,4.812-.407,.407-6.574-2.101-6.574-2.643,0-.271,.949-.339,2.101-.068,1.694,.339,2.101,.203,1.83-.542-.203-.542-.881-1.084-1.627-1.152-.678-.136-2.033-1.017-2.982-1.898-1.22-1.084-2.169-1.491-3.253-1.152-.949,.203-2.033-.068-2.846-.813-1.694-1.491-6.845-2.101-10.03-1.084-1.355,.407-5.083,1.491-8.268,2.372-6.167,1.762-7.59,3.253-3.389,3.66,2.643,.271,4.066,1.152,4.066,2.575,0,1.288-1.762,1.22-2.304-.068-.542-1.491-1.559-1.22-1.965,.407-.271,1.084-.745,1.355-1.762,1.084-2.304-.61-1.762,1.83,1.017,4.541,2.508,2.44,3.456,2.508,5.828,.474,.813-.678,1.017-1.559,.745-2.643-.339-1.491-.271-1.559,1.017-.881,2.236,1.152,4.947,5.151,4.473,6.438-.203,.61-.068,1.559,.407,2.101,.407,.542,.61,1.559,.339,2.304-.339,1.017,.068,1.898,1.491,3.117,1.017,.881,2.304,1.694,2.846,1.694,.474,0,1.762,.745,2.779,1.627,1.83,1.491,8.471,3.05,9.352,2.101,.203-.203-.745-1.355-2.101-2.643-1.83-1.627-2.372-2.575-2.033-3.727,.542-2.169,1.22-2.236,3.253-.339,1.017,.949,2.236,1.559,2.711,1.355,.542-.203,1.288,.136,1.762,.678,.474,.61,2.033,1.627,3.456,2.372s2.914,1.83,3.321,2.508c.61,.949,1.423,1.084,4.88,.813,4.88-.474,7.997-1.898,10.098-4.744,.813-1.152,1.898-2.033,2.44-2.033,.678,0,.813,.271,.271,.881-.407,.407-.61,2.033-.61,3.524l.136,2.711,2.846-.136c1.559-.068,3.727-.61,4.88-1.152,1.084-.61,2.643-1.084,3.389-1.084s2.711-.745,4.405-1.694c3.592-1.965,5.489-2.236,3.253-.407-2.101,1.762-11.724,5.422-16.672,6.303-4.676,.813-24.262,1.559-24.872,.881h0Zm55.64-28.735c0-.813-1.355-1.694-1.83-1.22s.407,1.83,1.22,1.83c.339,0,.61-.271,.61-.61h0Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.482,460.102c-3.05-2.44-8.133-7.929-9.352-10.233-.271-.542,.474,.203,1.762,1.694,3.05,3.727,7.319,7.929,9.759,9.691,1.152,.813,1.83,1.491,1.559,1.491-.203,0-1.898-1.152-3.727-2.643Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.529,457.324c.745-1.423,3.253-3.05,3.863-2.44,.474,.407-2.914,3.795-3.863,3.795-.542,0-.542-.407,0-1.355Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.373,457.324c0-.339,.407-.678,.949-.678s1.22,.339,1.423,.678c.203,.407-.203,.678-.949,.678-.813,0-1.423-.271-1.423-.678Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.257,455.494q-1.017-2.236,1.288-1.152c2.372,1.22,2.575,2.033,.745,2.508-.881,.203-1.491-.203-2.033-1.355Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.967,454.884c-1.152-.881-1.22-1.084-.339-1.627,1.491-.949,2.508-.813,2.982,.407,.407,1.084,0,2.304-.813,2.304-.271,0-1.084-.474-1.83-1.084h0Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.57,454.884c-9.352-.61-21.348-3.05-21.348-4.337,0-.407-.407-.678-.949-.678-1.017,0-5.828-2.575-5.828-3.117,0-.136,1.152,.271,2.575,.881,5.083,2.169,6.913,2.779,10.979,3.66,4.337,.881,17.959,2.101,22.229,1.965,2.101-.068,3.524,.203,3.524,.61s-.678,.745-1.491,.745c-.881,0-2.643,.136-3.931,.271-1.288,.136-3.863,.136-5.761,0h0Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.579,450.479c.542-.813,3.795-2.169,4.202-1.694,.339,.271-3.389,2.44-4.202,2.44-.203,0-.203-.339,0-.745Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.439,448.581c0-.339,1.084-1.423,2.44-2.44,2.169-1.627,2.643-1.762,4.202-1.084,1.423,.678,1.559,.949,.745,1.491-.474,.339-1.627,.61-2.372,.61-.813,0-1.83,.474-2.304,1.017-.949,1.084-2.711,1.355-2.711,.407h0Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.243,443.973c-.949-1.084-1.965-2.575-2.236-3.389-.678-2.372,1.355-1.965,2.372,.474,.474,1.084,1.22,2.372,1.762,2.779,1.017,.881,1.288,1.965,.407,1.965-.339,0-1.355-.813-2.304-1.83h0Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.422,443.634c2.236-2.711,3.253-3.185,2.914-1.423-.136,.61-1.288,1.762-2.575,2.508l-2.372,1.355,2.033-2.44h0Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.347,443.77c-.339-.61,4.27-3.389,5.761-3.389,1.084,0,.813,1.694-.542,2.914s-4.541,1.559-5.218,.474Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.371,431.842c-2.236-.949-3.253-1.491-2.304-1.355,2.101,.474,6.709,2.304,6.709,2.779,0,.407,.407,.542-4.405-1.423Z",
    fill: "#d98033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.007,430.893c.745-.339,1.83-.61,2.372-.61,.61,0,.542,.271-.339,.61-.745,.339-1.83,.61-2.372,.61-.61,0-.542-.271,.339-.61Z",
    fill: "#d98033"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M280.024,420.781h163.802c2.208,0,4,1.792,4,4v52.663c0,2.76-2.24,5-5,5h-161.802c-2.76,0-5-2.24-5-5v-52.663c0-2.208,1.792-4,4-4Z",
    fill: "none",
    stroke: "#7f7e82",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.28,380.92v20.23H253.57v-20.23c0-6.6,5.4-12,12-12h192.71c6.6,0,12,5.4,12,12Z",
    fill: "#292c2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.282,527.39v10.6c0,6.6-5.4,12-12,12h-192.71c-6.6,0-12-5.4-12-12v-10.6c0,6.6,5.4,12,12,12h192.71c6.6,0,12-5.4,12-12Z",
    fill: "#9d9289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.682,537.69v12.3h-81.52v-12.3c0-3.86,3.14-7,7-7h67.52c3.86,0,7,3.14,7,7Z",
    fill: "#6d6866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.685,537.69v12.3h-79.52v-12.3c0-3.31,2.68-6,6-6h67.52c3.32,0,6,2.69,6,6Z",
    fill: "#9d9289"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.541,
    y: 404.564,
    width: 31.988,
    height: 10.455,
    rx: 5.228,
    ry: 5.228,
    fill: "#918a87"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.711,
    y: 519.514,
    width: 1.782,
    height: 19.176,
    fill: "#140401"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.832,516.38h-161.81c-3.03,0-5.5,2.47-5.5,5.5v28.11h1v-28.11c0-2.48,2.02-4.5,4.5-4.5h161.81c2.48,0,4.5,2.02,4.5,4.5v28.11h1v-28.11c0-3.03-2.47-5.5-5.5-5.5Z",
    fill: "#564e48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.825,477.447v3.37c0,2.76-2.24,5-5,5h-161.8c-2.77,0-5-2.24-5-5v-3.37c0,2.76,2.23,5,5,5h161.8c2.76,0,5-2.24,5-5Z",
    fill: "#140401"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.354,
    cy: 388.524,
    rx: 2.896,
    ry: 2.495,
    fill: "#828a92"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 329.755,
    cy: 388.524,
    rx: 2.896,
    ry: 2.495,
    fill: "#828a92"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.032,
    cy: 388.524,
    rx: 2.896,
    ry: 2.495,
    fill: "#828a92"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.369,
    cy: 388.524,
    rx: 2.896,
    ry: 2.495,
    fill: "#828a92"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.844,
    cy: 388.97,
    rx: 8.554,
    ry: 5.614,
    fill: "#828a92"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.27,
    cy: 388.524,
    rx: 5.168,
    ry: 3.03,
    fill: "#828a92"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 339.082,
    y: 383.356,
    width: 31.248,
    height: 13.01,
    rx: 2,
    ry: 2,
    fill: "#15110d"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M637.594,306.57H156.395V0h28.667c3.521,.47,7.065,.93,10.608,1.34,53.942,6.28,110.739,1.74,166.184,3.64,19.369,.66,38.588,2.12,57.957,2.85,19.584,.73,39.297,.72,58.945,.71,25.618-.02,51.343-.04,76.596-1.97,16.127-1.23,32.425-3.25,48.595-2.12,6.163,.42,12.197,1.3,18.424,1.39,4.875,.06,10.049-.47,13.807-1.84l1.417,302.57Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(189.77 228.822)",
    fontFamily: "Lato-Black, Lato",
    fontSize: 31,
    letterSpacing: ".14em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A4"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 44
  }, "PRINTER")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA4Printer);
export default __webpack_public_path__ + "static/media/a4-printer.3fa0b08b588d2170c086cdc8339aeecb.svg";
export { ForwardRef as ReactComponent };